/**
 * Shared styling constants for native HTML select elements.
 *
 * These styles ensure consistent appearance and theme support across
 * all select elements in the application.
 */

export const SELECT_BASE_STYLES =
  'rounded-md border border-input bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-50 disabled:cursor-not-allowed';
